import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './scripts/axios';

import 'normalize.css';
import 'animate.css';
import './styles/style.scss';
import './index.scss';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// 客户端脚本加载完成

const container = document.getElementById('root');
if (container) {
  // 检查是否有服务端渲染的 HTML
  const hasServerRenderedContent = container.children.length > 0;
  
  
  const app = (
    <BrowserRouter>
      {/* @ts-ignore */}
      <App staticContext={window.__INITIAL_VALUES__ || {}} />
    </BrowserRouter>
  );
  
  if (hasServerRenderedContent) {
    try {
      // 有服务端渲染内容，使用 hydration
      hydrateRoot(container, app);
    } catch (error) {
      // Hydration failed, falling back to client render
      // 清空容器，重新渲染
      container.innerHTML = '';
      const root = createRoot(container);
      root.render(app);
    }
  } else {
    // 没有服务端渲染内容，使用纯客户端渲染
    const root = createRoot(container);
    root.render(app);
  }
} else {
  console.error('Root container not found!');
}

// Performance monitoring removed - using built-in browser dev tools instead
